import axios from "axios";
const PostCodeLookUp = {
  lookUp: (postCode: string): Promise<boolean> =>
    axios
      .get(`https://api.postcodes.io/postcodes/${encodeURIComponent(postCode)}`)
      .then((res) => {
        if (res.status === 200) return true;
        return false;
      })
      .catch((err) => {
        throw err;
      }),
};

export default PostCodeLookUp;
